import type { BoxProps } from "@chakra-ui/react";
import { NewHireJourneyTag } from "design-system";
import { newHireJourneyPathById } from "helpers/url/pages/v1";
import { useNewHireJourneyDetailQuery } from "../hooks";

interface NewHireStackedLabelProps extends BoxProps {
  journeyId?: string;
  name?: string;
  label?: string;
  /**
   * When true, tints the pill so it reads as the anchoring identity in a row of
   * sibling attribute pills. Use in the action attribute row; leave off when
   * the label stands alone.
   */
  emphasized?: boolean;
}

export default function NewHireStackedLabel({
  journeyId,
  name: nameProp,
  label = "Onboarding Journey",
  emphasized = false,
  ...rest
}: NewHireStackedLabelProps) {
  const { data: journey } = useNewHireJourneyDetailQuery(journeyId, { enabled: !!journeyId });

  const displayName = journey?.newHire?.fullName ?? nameProp;
  const href = journey ? newHireJourneyPathById(journey.id) : undefined;
  const avatarUrl = journey?.newHire?.avatarUrl ?? undefined;

  if (!displayName) return null;

  const emphasisProps: BoxProps = emphasized
    ? {
      bg: "cdsIndigo.50",
      borderColor: "cdsIndigo.200",
      _hover: { bg: "cdsIndigo.100", borderColor: "cdsIndigo.300" },
    }
    : {};

  return (
    <NewHireJourneyTag
      name={displayName}
      avatarUrl={avatarUrl}
      label={label}
      href={href}
      {...emphasisProps}
      {...rest}
    />
  );
}
